// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-input {
    width: 100%;
    max-width: 100%;
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.5715;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fff;
    transition: all 0.3s;
    outline: none;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, sans-serif;
    box-sizing: border-box;
}

.phone-input:hover {
    border-color: #40a9ff;
}

.phone-input:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.phone-input::placeholder {
    color: #bfbfbf;
}

.phone-input:disabled {
    color: rgba(0, 0, 0, 0.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PhoneInput.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb;2CACuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":[".phone-input {\n    width: 100%;\n    max-width: 100%;\n    padding: 4px 11px;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    font-size: 14px;\n    line-height: 1.5715;\n    color: rgba(0, 0, 0, 0.85);\n    background-color: #fff;\n    transition: all 0.3s;\n    outline: none;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n        \"Helvetica Neue\", Arial, sans-serif;\n    box-sizing: border-box;\n}\n\n.phone-input:hover {\n    border-color: #40a9ff;\n}\n\n.phone-input:focus {\n    border-color: #40a9ff;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n.phone-input::placeholder {\n    color: #bfbfbf;\n}\n\n.phone-input:disabled {\n    color: rgba(0, 0, 0, 0.25);\n    background-color: #f5f5f5;\n    border-color: #d9d9d9;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
